export default "__VITE_ASSET__2d897b5e__"